import { SyntheticEvent, useCallback } from 'react';

import {
  FilledTextFieldProps,
  OutlinedTextFieldProps,
  StandardTextFieldProps,
  TextField
} from '@mui/material';
import { usePostHog } from 'posthog-js/react';

import { debounce } from '@/utils/debounce';

export type PostHogTextFieldType =
  | ({
      id: string;
    } & FilledTextFieldProps)
  | OutlinedTextFieldProps
  | StandardTextFieldProps;

const PostHogTextField = (props: PostHogTextFieldType) => {
  const posthog = usePostHog();

  const capturePostHogSearch = useCallback(
    (inputValue: string) => {
      debounce(() => {
        if (inputValue.trim() !== '') {
          posthog?.capture('gxgo_text_field_submitted', {
            id: props.id,
            searchValue: inputValue
          });
        }
      }, 2000);
    },
    [posthog, props.id]
  );

  const handleCaptureEvent = (event: SyntheticEvent) => {
    capturePostHogSearch(String(props.value ?? ''));
    props[event.type as keyof typeof props]?.(event);
  };

  return (
    <TextField
      {...props}
      variant={props.variant}
      onClick={e => {
        handleCaptureEvent(e);
      }}
      onKeyDown={e => {
        handleCaptureEvent(e);
      }}
    />
  );
};

export default PostHogTextField;
